import { UserAvatar } from '@/components/ui/user-avatar'
import { cn } from '@/lib/utils'
import type { Broker } from '@/models/broker'

interface BrokerAvatarProps {
  broker: Broker
  className?: string
}

/** The broker headshot — the same circular crop the bound-policy email uses. */
export function BrokerAvatar({ broker, className }: BrokerAvatarProps) {
  return (
    <UserAvatar
      name={broker.name}
      src={broker.photoUrl}
      className={cn('size-12', className)}
      fallbackClassName="font-sans text-sm font-bold"
    />
  )
}
